import React from 'react'

export default function leftArrowSvg(props) {
  return (
    <svg style={{ cursor: props.cursor ? props.cursor : "" }} xmlns="http://www.w3.org/2000/svg" width="11" height="20" viewBox="0 0 11 20"><path fill="#000" fillRule="evenodd" d="M299.634 6519.292a1.063 1.063 0 0 0-1.464 0l-8.563 8.264a1.95 1.95 0 0 0 0 2.827l8.625 8.325c.4.385 1.048.39 1.454.01a.975.975 0 0 0 .01-1.425l-7.893-7.617a.975.975 0 0 1 0-1.414l7.83-7.557a.974.974 0 0 0 0-1.413" transform="translate(-289 -6519)" /></svg>
  )
}
